import {AfterViewInit, ApplicationRef, Component, EventEmitter, Input, OnInit, Output, Renderer2} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {TunapayService} from "../../services/tunapay.service";

import {FormaDePagamento} from "../../objeto/FormaDePagamento";
import {TunapayScript} from "./tunapay.script";
import {MyDetectorDevice} from "../../app/shared/MyDetectorDevice";
import {TunapayGlobalComponent} from "../tunapay-global.component";



@Component({
  selector: 'app-tunnapay-digitais',
  templateUrl: './tunapay-carteirasdigitais.component.html',
  styleUrls: ['./tunapay-carteirasdigitais.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})

export class TunapayCarteirasDigitaisComponent extends TunapayScript implements OnInit, AfterViewInit {
  @Input() formaDePagamento: any = {};
  @Input() pedido: any = {};
  @Input() layoutLinkPedido = false;
  @Output() definiuCartao = new EventEmitter();
  @Output() escolheuFormaPagamento = new EventEmitter();
  @Output() redirecionarParaCarteirasDigitais = new EventEmitter(); // NOVO

  processando = false;

  msgErro: string;
  timerAbaAberta: any;
  isMobile: boolean;
  googlePayDisponivel = false;
  applePayDisponivel = false;
  formaPagamentoGooglePay: any;
  formaPagamentoApplePay: any;
  urlRedirect: string
  timerPagamentoDigital: any;
  carteiraDigitalProcessando: string;
  cancelarPopupPagamentoDigital: Function;
  constructor(protected tunapayService: TunapayService, protected app: ApplicationRef,
              protected renderer: Renderer2,   private detectorDevice: MyDetectorDevice) {
    super(tunapayService, app, renderer)
    this.formaPagamentoGooglePay = new FormaDePagamento()
    this.formaPagamentoApplePay = new FormaDePagamento();
    this.isMobile = this.detectorDevice.isMobile();
  }

  ngOnInit(): void {
    Object.assign(this.formaPagamentoGooglePay, this.formaDePagamento)
    this.formaPagamentoGooglePay.carteiraDigital = 'GooglePay';

    Object.assign(this.formaPagamentoApplePay, this.formaDePagamento)
    this.formaPagamentoApplePay.carteiraDigital = 'ApplePay';

    //ja esta selecionado
    if(this.pedido.pagamento.formaDePagamento){
      if(this.pedido.pagamento.formaDePagamento.carteiraDigital === 'GooglePay')
        this.formaPagamentoGooglePay =  this.pedido.pagamento.formaDePagamento
      if(this.pedido.pagamento.formaDePagamento.carteiraDigital === 'ApplePay')
        this.formaPagamentoApplePay =  this.pedido.pagamento.formaDePagamento
    }

    this.tunapayService.obtenhaUrlRedirect(this.pedido.guid).then((url) => {
      this.urlRedirect = url;
    })
  }

  ngAfterViewInit(): void {
    this.inicializeTuna(this.pedido.guid).then((err) => {
       if(!err){
         // Configura Google Pay após inicializar Tuna
         this.configureGooglePay();
         this.configureApplePay();
       }
    });
  }

  private configureGooglePay() {
    const merchantInfo = {
      merchantId: 'BCR2DN6TR7QYLIKK'
    };

    const transactionInfo = {
      transactionId: new Date().getTime(),
      totalPriceStatus: 'FINAL',
      totalPrice: 1,
      currencyCode: "BRL",
      countryCode: "BR"
    };

    // Callback quando o pagamento for concluído
    const checkoutCallback = async (response: any) => {

    };

    try {
      // Configura o Google Pay usando a API do Tuna
      this.tunaInstance.useGooglePay(
        '#google-pay-container', // ID do container do botão
        merchantInfo,
        checkoutCallback,
        null,
        transactionInfo
      )

      this.googlePayDisponivel = true;
    } catch (err) {
      this.googlePayDisponivel = false;
      console.error('Erro ao configurar Google Pay:', err);
    }

  }

  private configureApplePay() {
    const applePaySettings = {
      buttom: {
        selector: '#applePayDiv',
        style: {
          buttonStyle: "black",
          type: "check-out",
          locale: "pt-BR",
          width: "10px",
          height: "10px",
          borderRadius: "10px",
          padding: "10px",
          boxSizing: "10px"
        }
      },
      applePayCallback: async (applePayPayload: any) => { },
      cart: {
        lineItems: [{
          label: "Pedido",
          amount: (this.pedido.obtenhaValorAhPagar()).toFixed(2)
        }],
        total: {
          label: "Total do Carrinho",
          amount: {value: (this.pedido.obtenhaValorAhPagar()).toFixed(2), currency: "BRL"}
        }
      },
      merchantId: 'merchant.uy.tunahmlg',
      displayName: 'fibo.meucardapio',
    };

    console.log(applePaySettings)

    this.tunaInstance.useApplePay(applePaySettings)
      .then((flag, err) => {
        console.log('Apple Pay  run: ' + flag);
        this.applePayDisponivel = flag;
        this.app.tick();
      })
      .catch((err: any) => {
        console.error('Erro detalhado ao configurar Apple Pay:', err);
        this.applePayDisponivel = false;
        this.app.tick();
      });
  }

  escolheuPagamentoApplePay() {
    if (this.applePayDisponivel) {
      this.pedido.calculeTotal();
      this.prepararRedirecionamento('ApplePay');
    }
  }

  escolheuPagamentoGoogle() {
    this.pedido.calculeTotal();

    if(this.googlePayDisponivel)
        this.prepararRedirecionamento('GooglePay');

  }

  private prepararRedirecionamento(carteira: string) {
    this.msgErro = null;
    this.carteiraDigitalProcessando = carteira;

    // pega largura e altura da tela
    let erro = TunapayGlobalComponent.abraModalPagamentoExterno(this.urlRedirect, carteira,
      this.isMobile, false, (result: any ) => {

      if(result.cancelou){
        this.finalizeRetornoPagamentoDigital(true);
        return;
      }

      if(result.fechou || result.executou){
        this.finalizeRetornoPagamentoDigital(result.fechou);
      }
    }, (controle: any) => {
      this.cancelarPopupPagamentoDigital = controle.cancelar;
    } );

    if(!erro){
      this.processando = true;
      this.pedido.pagamento.processando = true;
      this.timerPagamentoDigital = setTimeout(() => {
        this.msgErro = 'Tempo limite para retorno do pagamento. Tente novamente ou escolha outra forma de pagamento.'
        this.finalizeRetornoPagamentoDigital(true);
      }, 300000);
      this.salveDadosPedidoTemporario(carteira);
    } else {
      this.limpeProcessandoPagamentoDigital();
      this.msgErro = erro
    }
  }

  private limpeProcessandoPagamentoDigital(){
    if(this.timerPagamentoDigital){
      clearTimeout(this.timerPagamentoDigital);
      this.timerPagamentoDigital = null;
    }

    this.processando = false;
    this.carteiraDigitalProcessando = null;
    this.cancelarPopupPagamentoDigital = null;
    if(this.pedido && this.pedido.pagamento)
      this.pedido.pagamento.processando = false;
  }

  cancelePagamentoDigital(){
    if(this.cancelarPopupPagamentoDigital){
      this.cancelarPopupPagamentoDigital();
    } else {
      this.finalizeRetornoPagamentoDigital(true);
    }
  }

  private finalizeRetornoPagamentoDigital(cancelou: boolean){
    this.limpeProcessandoPagamentoDigital();

    this.tunapayService.obtenhaDadosTemporarios(this.pedido.guid).then( (resp: any) => {
      if(resp.cartao){
        this.definaCartaoDigital(resp.cartao);
        return;
      }

      if(cancelou)
        this.limpePagamentoDigitalSelecionado();
    }).catch((err2: any) => {
      if(cancelou){
        this.limpePagamentoDigitalSelecionado();
        return;
      }

      this.msgErro = err2
    })
  }

  private definaCartaoDigital(cartao: any){
    for(let key of Object.keys(cartao))
      this.cartao[key]  = cartao[key]

    console.log(this.cartao)
    this.definiuCartao.emit(this.cartao)
  }

  private limpePagamentoDigitalSelecionado(){
    if(!this.pedido || !this.pedido.pagamento)
      return;

    if(this.pedido.pagamento.formaDePagamento?.carteiraDigital){
      this.pedido.pagamento.formaDePagamento = null;
      this.pedido.pagamento.dadosCartao = null;
    }
  }

  private   salveDadosPedidoTemporario(carteiraDigital: string ){
    const dadosPedido = {
      sessionId: this.tunaInstance.sessionID,
      env: this.tunaInstance.env,
      guid: this.pedido.guid,
      valorPagamento: this.pedido.obtenhaValorAhPagar(),
      formaDePagamento: carteiraDigital === 'GooglePay' ?
        this.formaPagamentoGooglePay.id : this.formaPagamentoApplePay.id,
      carteiraDigital: carteiraDigital,
      parentOrigin:  window.location.origin,
    };

    this.tunapayService.salveDadosTemporarios(dadosPedido).then( () => {  }).catch((erro) => {
      this.msgErro = erro;
      this.limpeProcessandoPagamentoDigital();
    })

  }
}
